/* eslint-disable @atlaskit/ui-styling-standard/no-dynamic-styles */
/* eslint-disable @atlaskit/ui-styling-standard/no-exported-styles */
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */
import styled from '@emotion/styled';

import { B300, N200 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const AIAnswerFeedbackWrapper = styled.div<{
	isCompact?: boolean;
}>(({ isCompact }) => ({
	display: 'flex',
	alignItems: 'center',
	gap: isCompact ? token('space.025', '2px') : token('space.100', '8px'),
	font: token('font.body'),
	color: token('color.text.accent.gray', N200),
	padding: isCompact ? 'unset' : `${token('space.150', '12px')} ${token('space.300', '24px')}`,
}));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const AIAnswerReportDescriptionWrapper = styled.div({
	paddingBottom: token('space.200', '16px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const Rotate180IconWrapper = styled.span({
	svg: {
		transform: 'rotate(180deg)',
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const FeedbackButtonIconWrapper = styled.span<{
	active: boolean;
	isDisabled: boolean;
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles
}>(({ active, isDisabled }) => ({
	svg: {
		color: active ? B300 : `${token('color.text.subtlest', N200)} !important`,
	},
	cursor: isDisabled ? 'not-allowed' : 'default',
}));
